const middleware = {}

middleware['expdanded-locations'] = require('../middleware/expdanded-locations.js')
middleware['expdanded-locations'] = middleware['expdanded-locations'].default || middleware['expdanded-locations']

export default middleware
